module.exports = __webpack_public_path__ + "image/video_list_img4.jpg";